import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FuseTranslationLoaderService } from '../../../core/services/translation-loader.service';
import { locale as english } from './i18n/en';
import { locale as turkish } from './i18n/tr';
import { Http, Headers } from '@angular/http';
import { fuseAnimations } from '../../../core/animations';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../../environments/environment';
import { AngularFirestore } from 'angularfire2/firestore';
import { ApiService } from '../../../core/services/api.service';

@Component({
    selector: 'fuse-sample',
    templateUrl: './sample.component.html',
    styleUrls: ['./sample.component.scss'],
    animations: fuseAnimations
})
export class FuseSampleComponent implements OnInit {

    sub: Subscription;
    sub1: Subscription;
    sub2: Subscription;
    allPosts = 0;
    allUser: any;
    allProducts: any;
    allBrands: any;
    loading = true;
    categories: any;
    constructor(private translationLoader: FuseTranslationLoaderService,
        private http: Http,
        private apiservice: ApiService,
        private cd: ChangeDetectorRef,
        private afs: AngularFirestore) {

        this.translationLoader.loadTranslations(english, turkish);
        this.categories = environment.categoriesModel;
    }
    ngOnInit(): void {
        this.getAllData().then(() => this.loading = false);

    }

    getAllData() {
        return Promise.all([
            this.getUsers(),
            this.getBrands(),
            this.getProduct(),
            this.getPosts()
        ]);

    }

    getUsers() {
        return new Promise<any>((resolve, reject) => {
            this.apiservice.sqlGet('corporate/totalUsers').toPromise().then((data) => {
                this.allUser = data[0].total;
                resolve({ user: this.allUser });
            });
        });
    }
    getPosts() {
        return new Promise<any>((resolve, reject) => {
            this.apiservice.sqlGet('corporate/totalPosts').toPromise().then((data) => {
                this.allPosts = data[0].total;
                resolve({ posts: this.allPosts });
            })

        });

    }

    getBrands() {
        return new Promise<any>((resolve, reject) => {
            this.apiservice.sqlGet('corporate/totalBrand').toPromise().then((data) => {
                this.allBrands = data[0].total;
                resolve({ brand: this.allBrands });
            });
        });
    }

    getProduct() {
        return new Promise<any>((resolve, reject) => {
            this.apiservice.sqlGet('corporate/totalProduct').toPromise().then((data) => {
                this.allProducts = data[0].total;
                resolve({ product: this.allProducts });
            });

        });
    }

    ngOnDestroy(): void {

    }

    async chooseByDay(num) {


        if (num !== '') {
            this.allPosts = 0;
            this.allUser = 0;
            await this.afs.collection('users').ref.orderBy('joinDate').startAt(Date.now() - 86400000 * num).endAt(Date.now()).get().then((data => {


                this.allUser = data.size;
                this.cd.markForCheck();
            }))
            await this.afs.collection('posts').ref.orderBy('modifyDate').startAt(Date.now() - 86400000 * num).endAt(Date.now()).get().then((data => {

                this.allPosts = data.size;
                this.cd.markForCheck();
            }))


        }
        else {
            this.getPosts();
            this.getUsers();

        }

    }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/sample/sample.component.ts